import { MeetingStepViewId } from '../../../../types'

// Note: I think DevelopmentAndTargets is not used anymore
// Adapted sorter, sorted unknown steps to the end

const appraisalStepPosition = (viewId: MeetingStepViewId): number => {
  switch (viewId) {
    case MeetingStepViewId.Intro:
      return 1
    case MeetingStepViewId.SelfReflection:
      return 2
    case MeetingStepViewId.Evaluation:
      return 3
    case MeetingStepViewId.DevelopmentAndTargets:
      return 4
    case MeetingStepViewId.PastTargets:
      return 4
    case MeetingStepViewId.Feedback:
      return 5
    case MeetingStepViewId.Payments:
      return 5
    case MeetingStepViewId.ContractChanges:
      return 6
    case MeetingStepViewId.NewTargets:
      return 7
    case MeetingStepViewId.Notes:
      return 8
    case MeetingStepViewId.MeetingNotes:
      return 9
    case MeetingStepViewId.Conclusion:
      return 10
    default:
      return 999
  }
}
const appraisalUpdateStepPosition = (viewId: MeetingStepViewId): number => {
  switch (viewId) {
    case MeetingStepViewId.Intro:
      return 1
    case MeetingStepViewId.SelfReflection:
      return 2
    case MeetingStepViewId.Evaluation:
      return 3
    case MeetingStepViewId.ContractChanges:
      return 4
    case MeetingStepViewId.NewTargets:
      return 5
    case MeetingStepViewId.Payments:
      return 6
    case MeetingStepViewId.Notes:
      return 7
    case MeetingStepViewId.Feedback:
      return 7
    case MeetingStepViewId.MeetingNotes:
      return 8
    case MeetingStepViewId.Conclusion:
      return 9
    default:
      return 999
  }
}

export const sortSteps = (steps: MeetingStepViewId[], isAppraisalUpdate: boolean): MeetingStepViewId[] =>
  steps.sort((step1, step2) => {
    const step1Pos = isAppraisalUpdate ? appraisalUpdateStepPosition(step1) : appraisalStepPosition(step1)
    const step2Pos = isAppraisalUpdate ? appraisalUpdateStepPosition(step2) : appraisalStepPosition(step2)
    return step1Pos - step2Pos
  })
